/*
* Broadcast Theme
*
* Use this file to add custom Javascript to Broadcast.  Keeping your custom
* Javascript in this fill will make it easier to update Broadcast. In order
* to use this file you will need to open layout/theme.liquid and uncomment
* the custom.js script import line near the bottom of the file.
*/


(function() {
  // Add custom code below this line

/* Open external links in a new tab */
document.addEventListener('DOMContentLoaded', function() {
  const links = document.querySelectorAll('a[href]');
  const currentHost = window.location.hostname;

  links.forEach(link => {
    const linkHost = new URL(link.href).hostname;
    if (linkHost && linkHost !== currentHost) {
      link.setAttribute('target', '_blank');
      link.setAttribute('rel', 'noopener noreferrer');
    }
  });
});


  // ^^ Keep your scripts inside this IIFE function call to 
  // avoid leaking your variables into the global scope.
})();
